import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelpersService } from './helpers.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private url!: string;
  private authUrl!: string;
  private urlPc!: string;


  constructor(private router: Router, private httpClient: HttpClient) {}

  loadConfig() {
    this.url = HelpersService.api('users');
    this.authUrl = HelpersService.api('auth');
    this.urlPc = HelpersService.api('pc');
  }

  public register(body: any) {
    return this.httpClient.post(this.url, body);
  }

  public resetPasswordAndSendEmailAdmin(body: any) {
    return this.httpClient.post(
      this.url + '/reset-and-send-email-password-admin',
      body
    );
  }

  public registerAdmin(body: any): Observable<any> {
    return this.httpClient.post(this.url + '/admin', body);
  }

  public inviteAdmin(body: any): Observable<any> {
    const payload = { ...body, nodeEnv: 'developer' };
    return this.httpClient.post(this.url + '/invite-admin', payload);
  }
  public createAdminPassword(body: any): Observable<any> {
    return this.httpClient.post(this.url + '/create-admin-password', body);
  }

  public updateProfile(id: any, body: any): Observable<any> {
    return this.httpClient.patch(this.url + '/' + id, body);
  }

  public updateAdminProfile(id: any, body: any): Observable<any> {
    return this.httpClient.patch(this.url + '/update-admin/' + id, body);
  }

  public getMembers(body: any): Observable<any> {
    return this.httpClient.post(this.url + '/get-users', body);
  }

  public getMemberById(id: string): Observable<any> {
    return this.httpClient.get(this.url + '/' + id);
  }

  public getAdmins(body: any): Observable<any> {
    return this.httpClient.post(this.url + '/get-admins', body);
  }

  public getProfile(id: string): Observable<any> {
    return this.httpClient.get(this.url + '/' + id);
  }

  public getProfileByToken(): Observable<any> {
    return this.httpClient.get(this.url + '/by-token');
  }

  public getProfilePc(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/user-profile', body);
  }

  public getCoupons(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/find-ecoupon-list', body);
  }

  public getQuests(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/find-quest-list', body);
  }

  public getCampaigns(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/find-campaign-list', body);
  }

  public scanQuest(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/scan-quest', body);
  }

  public scanECoupon(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/scan-ecoupon', body);
  }

  public scanCampaign(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/scan-campaign', body);
  }

  public preScanEcoupon(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/pre-scan-ecoupon', body);
  }

  public preScanQuest(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/pre-scan-quest', body);
  }
  public preScanCampaign(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/pre-scan-campaign', body);
  }
  public forgotPassword(email: any): Observable<any> {
    var body = {
      email: email,
      path: '/auth/reset-password',
      from: 'pc'
    }
    return this.httpClient.post(this.url + '/forgot-password', body);
  }
  public resetPassword(body: any): Observable<any> {
    return this.httpClient.post(this.authUrl + '/reset-password', body);
  }

  public historyCampaign(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/history-campaign', body);
  }

  public historyQuest(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/history-quest', body);
  }

  public historyECoupon(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/history-ecoupon', body);
  }

  public historyAssistant(body: any): Observable<any> {
    return this.httpClient.post(this.urlPc + '/history-assistant-pc', body);
  }
}
